import PropTypes from 'prop-types';
import React from 'react';
import {
  MotifIcon,
  MotifFileUploaderItem,
  MotifIconButton,
} from '@ey-xd/motif-react';
import { IconoirDownload, IconoirPage } from '@ey-xd/motif-icon';

const CustomQuestionAttachmentList = ({
  attachmentList,
  handleDownloadAttachmentClick,
  className,
  fileSize = 0,
}) => {
  function onDownloadClick(e, fileName, attachmentGuid) {
    e.preventDefault();
    handleDownloadAttachmentClick(attachmentGuid, fileName);
  }
  return (
    <React.Fragment>
      <div data-testid="attachmentList">
        {attachmentList &&
          attachmentList.length > 0 &&
          attachmentList.map((attachmentData) => (
            <MotifFileUploaderItem
              className={className}
              fileIcon={<MotifIcon iconFunction={IconoirPage} size="24" />}
              title={attachmentData.attachmentName}
              customButton={
                <MotifIconButton
                  aria-label="Download Attachment"
                  type="button"
                  onClick={(e) =>
                    onDownloadClick(
                      e,
                      attachmentData.attachmentName,
                      attachmentData.attachmentGuid
                    )
                  }
                >
                  <MotifIcon
                    iconFunction={IconoirDownload}
                    size="24"
                    title="Download Attachment"
                  />
                </MotifIconButton>
              }
              fileName={attachmentData.attachmentName}
              fileSize={fileSize}
            />
          ))}
      </div>
    </React.Fragment>
  );
};

CustomQuestionAttachmentList.propTypes = {
  attachmentList: PropTypes.array,
  handleDownloadAttachmentClick: PropTypes.func,
  className: PropTypes.string,
  fileSize: PropTypes.number,
};

export default CustomQuestionAttachmentList;
